// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"10c69aa8","484":"85992b56","617":"cf679cca","629":"e3e47e7e","640":"fdd6361d","849":"0ec3eadc","869":"0e6b3ebf","974":"5956f516"}[chunkId] + ".chunk.js";
};